import React from "react";
import ReactDOM from "react-dom/client"; // ✅ updated import
import "./index.css";
import App from "./App";
import * as registerServiceWorker from "./registerServiceWorker";
import { Provider } from "react-redux";
import { store } from './redux_store';
// import { ClearBrowserCacheBoundary } from 'react-clear-browser-cache';

// ✅ Create root and use new render method
const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <Provider store={store}>
    {/* <React.StrictMode> */}
      {/* <ClearBrowserCacheBoundary auto fallback='Loading' duration={1000}> */}
        <App />
      {/* </ClearBrowserCacheBoundary> */}
    {/* </React.StrictMode> */}
  </Provider>
);

registerServiceWorker.unregister();
